import styled from 'styled-components/macro';
import { ButtonBrand } from 'components/ButtonBrand';
import { Row } from 'components/Row';
import { Image } from 'components/Image';
import Column from 'components/Column';

export const ConfirmationBackgroundContainer = styled.div<{ $backgroundColor?: string }>`
  background: ${({ theme, $backgroundColor }) => $backgroundColor || theme.colors.paleBlue};
  padding: 30px 20px;
  @media (min-width: 1030px) {
    padding: 38px 121px 50px;
  }
`;

export const ConfirmationContainer = styled(Row)`
  align-items: center;
  gap: 50px;
  text-align: center;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1150px;
  @media (min-width: 1030px) {
    align-items: flex-start;
    flex-direction: row;
    gap: 48px;
  }
`;

export const ConfirmationCardContainer = styled.div`
  width: 100%;
  @media (min-width: 450px) {
    width: 365px;
  }
`;

export const ConfirmationCardTitle = styled(Row)`
  justify-content: center;
  margin: 2px 0;
`;

export const ConfirmationCardContent = styled.div`
  padding: 13px 20px 18px;
  text-align: left;
`;

export const ConfirmationImage = styled(Image)`
  margin: 24px 0;
  max-height: 150px;
  max-width: 100%;
  @media (max-width: 1030px) {
    margin: 20px 0 0;
  }
`;

export const ConfirmationButtonRow = styled(Row)`
  gap: 8px;
  margin: 27px 0 44px;
  width: 365px;
  button,
  a {
    flex: 1;
    width: 100%;
  }
  @media (max-width: 1030px) {
    flex-direction: column;
    margin: 20px 0 0;
  }
  @media (max-width: 450px) {
    width: 100%;
  }
`;

export const ProcessingRow = styled(Row)`
  justify-content: center;
  margin-top: 6px;
  text-align: center;
`;

export const ConfirmationPaymentDisplay = styled.div`
  text-transform: capitalize;
`;

export const ProcessingCardContent = styled(Column)`
  text-align: center;
`;

export const ProcessingImage = styled(Image)`
  height: 34px;
  margin: 0 auto 34px;
`;

export const ProcessingImageSmallWhite = styled(Image)`
  height: 21px;
  margin-right: 8px;
`;

export const DonateAgainContainer = styled.div`
  margin: 0 auto;
  max-width: 1150px;
  text-align: center;
`;

export const DonateAgainCardsRow = styled(Row)`
  align-items: stretch;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 50px;
  margin-top: 37px;
  margin-left: auto;
  margin-right: auto;
  max-width: 375px;
  @media (min-width: 1030px) {
    flex-direction: row;
    margin-left: 0;
    margin-right: 0;
    max-width: none;
  }
`;

export const DonateAgainCardContainer = styled(Column)`
  flex: 0 0 calc(33.3333% - 36px);
`;

export const DonateAgainCardLearnMore = styled.div`
  bottom: 22px;
  position: absolute;
`;

export const ExploreOtherIssuesButton = styled(ButtonBrand)`
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 25px;
  @media (min-width: 800px) {
    margin-top: 46px;
    width: 375px;
  }
`;

export const ConfirmationContainerLeft = styled(Row)`
  align-items: center;
  text-align: center;
  flex-direction: column;
  max-width: 500px;
  @media (min-width: 1030px) {
    align-items: flex-start;
    text-align: left;
  }
`;

export const ConfirmationContainerRight = styled(Row)`
  align-items: center;
  flex-direction: column;
`;

export const DonateAgainJumpButton = styled(ButtonBrand)`
  @media (min-width: 1030px) {
    display: none;
  }
`;
